<template>
	<div>
		<!-- Boutons -------------------------------------------------------------------------------->
		<el-row>
			<!-- Boutons du primaire-->
			<el-col :md="24" :sm="24" :xs="24" class="primPos">
				<el-button-group tabPosition="left">
					<el-button size="medium" class="btn-select colorBtn" v-bind:class="focusCirc" @click="showContent('circ')" title="Circonstances">Circ<span class="hidden-xs-only">onstances</span></el-button>
					<el-button size="medium" class="btn-select colorBtn" v-bind:class="focusAdmin" @click="showContent('admin')" title="Administration">Admin<span class="hidden-xs-only">istration</span></el-button>
					<el-button size="medium" class="btn-select colorBtn" v-bind:class="focusInter" @click="showContent('inter')" title="Intervention">Interv<span class="hidden-xs-only">ention</span></el-button>
					<el-button v-if="this.administration.tep" size="medium" class="btn-select colorBtn" v-bind:class="focusTep" @click="showContent('tep')" title="TEP">TEP</el-button>
				</el-button-group>
			</el-col>
		</el-row>
					
		<el-divider></el-divider>

		<!-- Corps -------------------------------------------------------------------------------->                
		<CheckupTab v-bind="{column:column, parameters:parameters}"/>
	</div>
</template>

<script>
import CheckupTab from '@/components/checkup.detail.tab.component.vue';

export default {
	name: 'CheckupPart1',
	props: ['administration', 'initTab'],
	components: {
		CheckupTab
	},
	
	data() {
		return {
			parameters:{
				withTitle: false,
				classColor: "colorAdmin",
				borderLeft : "",
				borderRight : "" 
			},
			focusCirc : "focus",
			focusAdmin : "",
			focusInter : "",
			focusTep : "",
			column: {}
		};
	},

	methods: {
		showContent(tabName) {
			this.focusCirc = "";
			this.focusAdmin = "";
			this.focusInter = "";
			this.focusTep = "";
			let cols = {};
			cols.col00 = null;
			switch (tabName) {
				case 'circ':
					cols.leftTitle = this.administration.circ.libelle;
					cols.col00 = this.administration.circ.child0;
					cols.col01 = this.administration.circ.child1;
					cols.col02 = this.administration.circ.child2;
					cols.col03 = this.administration.circ.child3;
					this.focusCirc = "focus";
					break;
				case 'admin':
					cols.leftTitle = this.administration.admin.libelle;
					cols.col01 = this.administration.admin.child1;
					cols.col02 = this.administration.admin.child2;
					cols.col03 = this.administration.admin.child3;
					this.focusAdmin = "focus";
					break;
				case 'inter':
					cols.leftTitle = this.administration.inter.leftTitle;
					cols.col01 = this.administration.inter.col01;
					cols.col02 = this.administration.inter.col02;
					cols.col03 = this.administration.inter.col03;
					this.focusInter = "focus";
					break;
				case 'tep':
					cols.leftTitle = this.administration.tep.libelle;
					cols.col01 = this.administration.tep.child1;
					cols.col02 = this.administration.tep.child2;
					cols.col03 = this.administration.tep.child3;
					this.focusTep = "focus";
					break;
				default:
					break;
			}

			this.column = cols;
		}
	},

	watch: {
		initTab(tabName) {
			this.showContent(tabName);
		}
	},

	mounted() {
		if (this.initTab) {
			this.showContent(this.initTab);
		}
	}
};

</script>

<style scoped>

/*   classe des Boutons 
		 ---------------------------------------------
*/
.btn-select {
	color: #9c9c9c;
	background-color: #f7f7f7;
}

.btn-select:hover {
	background-color: #fcfcfc;
	color: #000000;
}

.btn-select.focus{
	margin-top: -0px;
	color: #000000;

}
.btn-select.focus.colorBtn {
	background-color: white;
	border-color: #b6b6b6;
	border-width: 1.5px;
} 

.btn-select.colorBtn:focus {
	background-color: white;
	border-color: #b6b6b6;
	border-width: 1.5px;
}

</style>